import { render, staticRenderFns } from "./StudentListStatuses.vue?vue&type=template&id=808ecef2&"
import script from "./StudentListStatuses.vue?vue&type=script&lang=js&"
export * from "./StudentListStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports